module.exports = __webpack_public_path__ + "static/depression-ae73617d20f4edeeebeea58b24c14807.png";